import { render, staticRenderFns } from "./EventStatCard.vue?vue&type=template&id=c63e8570&scoped=true"
import script from "./EventStatCard.vue?vue&type=script&lang=js"
export * from "./EventStatCard.vue?vue&type=script&lang=js"
import style0 from "./EventStatCard.vue?vue&type=style&index=0&id=c63e8570&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c63e8570",
  null
  
)

export default component.exports